/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEdge = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M12.53 2.152a1 1 0 0 0-1.06 0l-1 .625 1.06 1.696.47-.294.47.294 1.06-1.696zm-5 4.821 2-1.25-1.06-1.696-2 1.25zm6.94-1.25 2 1.25 1.06-1.696-2-1.25zM5 9h-.234l-.296.473L3.713 9H3V8a1 1 0 0 1 .47-.848l1-.625.603.964.457.286L5.39 8l.14.223-.457.286L5 8.625zm13.47-.777.457.286.073.116V9h.234l.296.473.757-.473H21V8a1 1 0 0 0-.47-.848l-1-.625-.603.964-.457.286.14.223zm-12 2.5 2 1.25 1.06-1.696-2-1.25zm9.06 1.25 2-1.25-1.06-1.696-2 1.25zM3 11v2h2v-2zm18 2v-2h-2v2zm-7.47.223-.53.331V14h-2v-.446l-.53-.331 1.06-1.696.47.294.47-.294zM3 15v1a1 1 0 0 0 .47.848l1 .625 1.06-1.696-.53-.331V15zm18 1v-1h-2v.445l-.53.332-2 1.25-2 1.25-2 1.25-.47.294-.47-.294-.296.473H11v.375l-.53.848 1 .625a1 1 0 0 0 1.06 0l8-5A1 1 0 0 0 21 16zm-10 0v2h2v-2zm-4.53 2.723 2 1.25 1.06-1.696-2-1.25z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgEdge as Edge };
